/* Section refreshes must use the current world, not a bare /cart or pathname. */
(() => {
  const worlds = ['snackshark', 'halloween', 'sparhelden'];
  const current = () => {
    const value = document.body.dataset.ssWorld;
    return worlds.includes(value) ? value : 'snackshark';
  };
  window.SSWorld = {
    current,
    sectionURL() {
      const currentURL = new URL(window.location.href);
      // Shopify bundled cart sections do not reliably preserve ?view. A real
      // collection pathname supplies an unambiguous server-side collection.
      const url = new URL(document.body.dataset.ssCollectionUrl || '/collections/' + current(), currentURL);
      const preview = currentURL.searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      return url.pathname + url.search;
    },
    cartURL() {
      const url = new URL(window.routes?.cart_url || '/cart', window.location.origin);
      url.searchParams.set('view', current());
      return url.pathname + url.search;
    }
  };
})();
